import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_DK: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'For mænd',
  components_header_media_2: 'For kvinder',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Træn smartere, få det bedre.',
  hero_button_text: 'Kom i gang nu',
  components_ressources_subheader_text: 'Guider og tips',
  components_ressources_span_text: 'Den kombinerer yogaens jordnære fokus, pilates\' kontrollerede præcision og styrketræningens dynamiske udfordring for at understøtte en alsidig og sund livsstil.',
  components_ressources_card_1_title: 'Yogatips',
  components_ressources_card_1_text: 'Hurtig guide til bedre balance, vejrtrækning og flow.',
  components_ressources_card_2_title: 'Pilates-tips',
  components_ressources_card_2_text: 'Enkle tips til at styrke dine kernemuskler og forbedre din kontrol.',
  components_notes_and_google_title_1: 'Opbyg styrke',
  components_notes_and_google_title_2: 'Yoga Ro',
  components_notes_and_google_title_3: 'Pilates kerne',
  media_content_section_multi_1_subheader_text: 'Træningsvideoer',
  media_content_section_multi_2_subheader_text: 'Yogavideoer',
  media_content_section_multi_3_subheader_text: 'Pilates-videoer',
  text_media_1: 'Mænd',
  text_media_2: 'Kvinder',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Tilbage',
  page_media_content_menu_chest: 'Bryst',
  page_media_content_menu_legs: 'Ben',
  page_media_content_menu_shoulders: 'Skuldre',
  page_media_content_menu_abdominals: 'Mavemuskler',
  components_text1_subheader_text: 'Sund kost til dit aktive liv',
  components_text1_span_text: 'Sunde opskrifter, der understøtter din træning og forbedrer dit velbefindende.',
  components_footer_text: 'Styrk din krop, balancer dit sind og bevæg dig med mening – dit sted for fitness, yoga og pilates.',
};